document.addEventListener('DOMContentLoaded', async function () {
  const desktopContainer = document.getElementById('okendo-featured-reviews-desktop');
  const mobileContainer = document.getElementById('okendo-featured-reviews-mobile');
  if (!desktopContainer || !mobileContainer) return;

  const apiUrl =
    'https://api.okendo.io/v1/stores/09f9e9e9-b49f-40fa-97fd-c71ee0c5e7c0/reviews?limit=10&orderBy=date%20desc';

  const verifiedIcon =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="#007849"/><path d="M4.5 8.2L6.7 10.4L11.5 5.4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> Verified Customer';

  function largeCardHtml(review) {
    return `
      <div class="testimonial-featured-card testimonial-featured-card--large">
        <img src="${review.productImageUrl}" class="testimonial-featured-card__image" alt="${review.productName}" width="190" height="190" loading="lazy" decoding="async">
        <div class="testimonial-featured-card__body">
          <span class="testimonial-featured-card__badge">${verifiedIcon}</span>
          <p class="testimonial-featured-card__product">${review.productName}</p>
          <p class="testimonial-featured-card__headline">${review.title || 'Customer Review'}</p>
          <p class="testimonial-featured-card__text">${review.body} - ${review.reviewer.displayName}</p>
        </div>
      </div>
    `;
  }

  function smallCardHtml(review) {
    return `
      <div class="testimonial-featured-card testimonial-featured-card--small">
        <img src="${review.productImageUrl}" class="testimonial-featured-card__image" alt="${review.productName}" width="90" height="90" loading="lazy" decoding="async">
        <div class="testimonial-featured-card__body">
          <span class="testimonial-featured-card__badge">${verifiedIcon}</span>
          <p class="testimonial-featured-card__product">${review.productName}</p>
          <p class="testimonial-featured-card__headline">${review.title || 'Customer Review'}</p>
          <p class="testimonial-featured-card__text">${review.body} - ${review.reviewer.displayName}</p>
        </div>
      </div>
    `;
  }

  function mobileCardHtml(review) {
    return `
      <div class="swiper-slide">
        <div class="testimonial-mobile-card">
          <span class="testimonial-mobile-card__badge">${verifiedIcon}</span>
          <p class="testimonial-mobile-card__product">${review.productName}</p>
          <p class="testimonial-mobile-card__headline">${review.title || 'Customer Review'}</p>
          <p class="testimonial-mobile-card__text">${review.body}</p>
          <img src="${review.productImageUrl}" class="testimonial-mobile-card__image" alt="${review.productName}" width="260" height="260" loading="lazy" decoding="async">
        </div>
      </div>
    `;
  }

  try {
    const response = await fetch(apiUrl);
    const data = await response.json();

    if (!data.reviews || !Array.isArray(data.reviews)) return;

    const validReviews = data.reviews.filter((review) => {
      return review.productName && review.productImageUrl && review.status === 'approved';
    });

    if (validReviews.length === 0) return;

    // Desktop: group reviews into sets of 3 (1 large + 2 small). Drop an incomplete trailing group.
    const groups = [];
    for (let i = 0; i + 3 <= validReviews.length; i += 3) {
      groups.push(validReviews.slice(i, i + 3));
    }
    // Fall back to a single partial group if there aren't enough reviews for a full set of 3.
    if (groups.length === 0) {
      groups.push(validReviews.slice(0, Math.min(3, validReviews.length)));
    }

    desktopContainer.innerHTML = groups
      .map((group) => {
        const [large, ...small] = group;
        return `
          <div class="swiper-slide">
            <div class="testimonial-featured-group">
              ${large ? largeCardHtml(large) : ''}
              <div class="testimonial-featured-group__side">
                ${small.map(smallCardHtml).join('')}
              </div>
            </div>
          </div>
        `;
      })
      .join('');

    // Mobile: one review per slide.
    mobileContainer.innerHTML = validReviews.map(mobileCardHtml).join('');

    new Swiper('.testimonials-featured__swiper-desktop', {
      slidesPerView: 1,
      spaceBetween: 24,
      loop: false,
      navigation: {
        nextEl: '.testimonials-featured__next',
        prevEl: '.testimonials-featured__prev',
      },
      pagination: {
        el: '.testimonials-featured__pagination-desktop',
        clickable: true,
      },
    });

    new Swiper('.testimonials-featured__swiper-mobile', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      loop: false,
      centeredSlides: false,
      navigation: {
        nextEl: '.testimonials-featured__next-mobile',
        prevEl: '.testimonials-featured__prev-mobile',
      },
      pagination: {
        el: '.testimonials-featured__pagination-mobile',
        clickable: true,
      },
    });
  } catch (err) {
    console.error('Error loading featured reviews from Okendo:', err);
  }
});
